import Loader from 'common/modules/loader'

const getAcknowledgementText = ({ state, popupId, optionId }) => {
    const product = Loader.selectors.popupGetProductByProductOptionId(state, optionId)
    const option = Loader.selectors.popupGetOptionById(state, optionId)
    const orderType = Loader.selectors.getOrderType(product, option)

    switch(orderType) {
        case 'subscription':
            return Loader.selectors.getAckPopupCustomTextFileNameById(state, popupId)
            break

        case 'pledge':
            return Loader.selectors.getAckPopupCustomTextFileNameById(state, popupId)
            break

        case 'trial':
            return Loader.selectors.getTrialCustomAckFileNameById(state, popupId)
            break

        case 'pass':
            return Loader.selectors.getAckPopupCustomTextFileNameById(state, popupId)
            break

        case 'single-donation':
            return Loader.selectors.getSingleDonoCustomAckFileNameById(state, popupId)
            break

        case 'recurring-donation':
            // eslint-disable-next-line max-len
            return Loader.selectors.getRecurringDonoCustomAckFileNameById(state, popupId)
            break

        default:
            return ''
            break
    }

}

export {
    getAcknowledgementText
}
